
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { AlertTriangle, Coins } from 'lucide-react';

interface TokenDepletionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onPurchaseClick: () => void;
}

const TokenDepletionModal: React.FC<TokenDepletionModalProps> = ({
  isOpen,
  onClose,
  onPurchaseClick
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="w-5 h-5 text-orange-500" />
            Out of Tokens
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4 text-center">
          <div className="p-6">
            <Coins className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <h3 className="text-lg font-semibold text-[#374151] mb-2">
              You're out of tokens!
            </h3>
            <p className="text-gray-600 mb-6">
              To continue using RemoteViz, you'll need to purchase more tokens. 
              Choose from our affordable token packages.
            </p>
          </div>

          <div className="flex gap-3">
            <Button
              variant="outline"
              onClick={onClose}
              className="flex-1"
            >
              Cancel
            </Button>
            <Button
              onClick={onPurchaseClick}
              className="flex-1 bg-[#5F436C] hover:bg-[#4A3556] text-white"
            >
              Buy Tokens
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default TokenDepletionModal;
